import { useQuery } from "@tanstack/react-query";
import {
	getBilletsRFactor,
	getBilletsRFactorPickers,
	type GetBilletsRFactorParams,
	type GetBilletsRFactorPickersParams,
} from "../repositories/BilletsRFactorRepository";

export const useBilletsRFactor = ({
	start,
	end,
	billetSizeId = null,
	crewId = null,
	productSizeId = null,
	productTypeId = null,
}: Omit<GetBilletsRFactorParams, "signal">) =>
	useQuery({
		queryKey: [
			"billetsRFactor",
			start,
			end,
			billetSizeId,
			crewId,
			productSizeId,
			productTypeId,
		],
		queryFn: ({ signal }) =>
			getBilletsRFactor({
				start,
				end,
				billetSizeId,
				crewId,
				productSizeId,
				productTypeId,
				signal,
			}),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});

export const useBilletsRFactorPickers = ({
	start,
	end,
}: Omit<GetBilletsRFactorPickersParams, "signal">) =>
	useQuery({
		queryKey: ["billetsRFactorPickers", start, end],
		queryFn: ({ signal }) => getBilletsRFactorPickers({ start, end, signal }),
		enabled: !!start && !!end,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
